/* Close Rise's mobile drawer before following a same-page section link. */
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a.hotiti-drawer-link');
  if (!link) return;
  const destination = new URL(link.href, window.location.href);
  if (!destination.hash || destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
  const drawer = link.closest('header-drawer');
  if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;
  const summary = drawer.querySelector('summary');
  drawer.closeMenuDrawer(event, summary);
  summary?.setAttribute('aria-expanded', 'false');
});
